import { compose, withStateHandlers, withHandlers, withProps, branch, renderComponent } from 'recompose'
import TMPSItem from './TPMSItem'
import OTDPItem from './OTDPItem'
import TPPItem from './TPPItem'
import { isTPMSItem, isTPPItem } from '../helpers'

const withDisabledState = withStateHandlers(({ mandatoryValues, name }) => ({
  disabled: mandatoryValues.includes(name)
}), {
  setDisabled: () => value => ({ disabled: value })
})

const withHandlePopoverClick = withHandlers({
  handlePopoverClick: ({ disabled, setDisabled }) => () => {
    if (!disabled) {
      setDisabled(!disabled)
      setTimeout(() => setDisabled(disabled))
    }
  }
})

const withEnhancedProps = withProps(({ commerceItemId, brand, mandatory, canBeEdited }) => ({
  genericId: `${brand}-${commerceItemId}`,
  displayCheckbox: !mandatory && canBeEdited
}))


export default compose(
  withDisabledState,
  withHandlePopoverClick,
  withEnhancedProps,
  branch(isTPMSItem, renderComponent(TMPSItem)),
  branch(isTPPItem, renderComponent(TPPItem)),
  branch(p => !isTPMSItem(p) && !isTPPItem(p), renderComponent(OTDPItem))
)(OTDPItem)
